import React from 'react';
import styles from './PortalTable.module.scss';

export interface Column {
  key: string;
  label: string;
}

interface PortalTableProps {
  columns: Column[];
  children: React.ReactNode;
  emptyMessage?: string;
  isEmpty?: boolean;
}

export default function PortalTable({ columns, children, emptyMessage = 'No data found', isEmpty }: PortalTableProps) {
  return (
    <div className={styles.contentCard}>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isEmpty ? (
              <tr>
                <td colSpan={columns.length} className={styles.emptyState}>
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              children
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
